<template>
    <div id="announcements-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Announcements</h1>

                <div class="table-header" style="margin-bottom:20px;">
                    <div class="table-header__tabs"></div>
                    <div class="table-header__controls">
                        <router-link to="/announcements/create" class="table-header__controls__btn">New Announcement</router-link>

                        <div class="table-header__controls__search">
                            <SearchBox placeholder="Search"
                                       @search="updateSearchText" />
                        </div>
                    </div>
                </div>

                <DataTable class="announcements-data-table"
                           :dataUrl="dataUrl"
                           :displayId="false"
                           :key="tableRefreshKey"
                           :dataFormatter="formatData"
                           :filterData="filterData"
                           @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>
            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/announcements'
import axios from 'axios'
import SearchBox from "@/components/global/SearchBox.vue";

export default {
    name: 'AnnouncementsIndex',
    components: {
        SearchBox,
        DataTable
    },
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null,
            filterData: {}
        }
    },
    methods: {
        updateSearchText(query) {
            if (!query || query === '') {
                //this.filterData['name'] = undefined
            }
            else {
                //this.filterData['name'] = query
            }
        },
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                for (let key in obj) {
                    const ignore = ['__v']
                    if (ignore.includes(key)) {
                        continue
                    }
                    else if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                const actions = {
                    'edit': `<i class="edit-action" title="Edit">Edit</i>`,
                    'delete': `<i class="delete-action" title="Delete">Delete</i>`
                }
                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89-2')
            }
            else if (actionKey === 'edit') {
                this.$router.push('/announcements/' + identifier)
            }
            else if (actionKey === 'delete') {
                if (confirm('Are you sure you want to delete this announcement?')) {
                    axios.delete(endpoint + '/' + identifier)
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                                alert('Error occurred')
                                console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while deleting')
                            console.log(error)
                        })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
